module.exports = __webpack_public_path__ + "img/cardano-logo.1fadd582.png";